import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
    selector: '[blackAccordianContent]',
    standalone: false
})
export class AccordianContentDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);


}
